// route - web
const Index = r => require.ensure([], () => r(require('@/web/app.vue')), 'route-site');
const Home = r => require.ensure([], () => r(require('@/web/site/home.vue')), 'route-site');
const ItemList = r => require.ensure([], () => r(require('@/web/site/item-list.vue')), 'route-site');
const ItemDetail = r => require.ensure([], () => r(require('@/web/site/item-detail.vue')), 'route-site');
const Register = r => require.ensure([], () => r(require('@/web/site/register.vue')), 'route-site');
const StuBind = r => require.ensure([], () => r(require('@/web/site/stu-bind.vue')), 'route-site');
const StuList = r => require.ensure([], () => r(require('@/web/site/stu-list.vue')), 'route-site');
const StuMain = r => require.ensure([], () => r(require('@/web/site/stu-main.vue')), 'route-site');
const StuInfo = r => require.ensure([], () => r(require('@/web/site/stu-info.vue')), 'route-site');
const StuRoll = r => require.ensure([], () => r(require('@/web/site/stu-roll.vue')), 'route-site');
const StuFee = r => require.ensure([], () => r(require('@/web/site/stu-fee.vue')), 'route-site');
const Signup = r => require.ensure([], () => r(require('@/web/site/signup.vue')), 'route-site');
const SignupPay = r => require.ensure([], () => r(require('@/web/site/signup-pay.vue')), 'route-site');
const User = r => require.ensure([], () => r(require('@/web/site/user.vue')), 'route-site');
const SignupOrder = r => require.ensure([], () => r(require('@/web/site/signup-order.vue')), 'route-site');
// const List = r => require.ensure([], () => r(require('@/web/site/list.vue')), 'route-site');
// const ListS = r => require.ensure([], () => r(require('@/web/site/list-signup.vue')), 'route-site');
// const Detail = r => require.ensure([], () => r(require('@/web/site/detail.vue')), 'route-site');
// const DetailS = r => require.ensure([], () => r(require('@/web/site/detail-signup.vue')), 'route-site');
// const OrderS = r => require.ensure([], () => r(require('@/web/site/order-signup.vue')), 'route-site');
// 关于
const About = r => require.ensure([], () => r(require('@/web/site/about.vue')), 'route-site');

const Weixin = r => require.ensure([], () => r(require('@/web/join/weixin.vue')), 'route-site');

const Ssign = r => require.ensure([], () => r(require('@/web/site/s-sign.vue')), 'route-site');

// 信息-商铺
// const Shop = r => require.ensure([], () => r(require('@/web/shop/shop.vue')), 'route-shop');
// const ShopGoods = r => require.ensure([], () => r(require('@/web/shop/goods.vue')), 'route-shop');
// const ShopGoodDetail = r => require.ensure([], () => r(require('@/web/shop/goods-detail.vue')), 'route-shop');
// const ShopRecommend = r => require.ensure([], () => r(require('@/web/shop/goods-recommend.vue')), 'route-shop');
// const ShopGoodsPay = r => require.ensure([], () => r(require('@/web/shop/goods-pay.vue')), 'route-shop');

// const ShopUser = r => require.ensure([], () => r(require('@/web/users/user.vue')), 'route-users');
// const UserDetail = r => require.ensure([], () => r(require('@/web/users/user-detail.vue')), 'route-users');
// const ShopOrder = r => require.ensure([], () => r(require('@/web/users/order.vue')), 'route-users');
// const ShopOrder0 = r => require.ensure([], () => r(require('@/web/users/order-0.vue')), 'route-users');
// const ShopOrderDetail = r => require.ensure([], () => r(require('@/web/users/order-detail.vue')), 'route-users');
// const UserAddress = r => require.ensure([], () => r(require('@/web/users/address.vue')), 'route-users');
// const UserAddressEdit = r => require.ensure([], () => r(require('@/web/users/address-edit.vue')), 'route-users');

// 信息
// const Info = r => require.ensure([], () => r(require('@/web/info/info.vue')), 'route-site-info');
// const InfoSignup = r => require.ensure([], () => r(require('@/web/info/signup.vue')), 'route-site-info');
// const InfoLookup = r => require.ensure([], () => r(require('@/web/info/lookup.vue')), 'route-site-info');

// const NotFound = r => require.ensure([], () => r(require('@/web/notfound.vue')), 'route-site-other');

export const webRoute = {
  home: {
    path: '/',
    component: Index,
    name: 'site-home',
    props: (route) => ({ token: route.query.t, hasLogin: route.params.hasLogin }),
    children: [
      {path:'', component:Home},
    ]
  },
  sites: [
    // {path:'/list/:id', component:List, name:'site-list', props:true},
    // {path:'/list-s/:id', component:ListS, name:'site-list-s', props:true},
    // {path:'/detail/:id', component:Detail, name:'site-view', props:true},
    // {path:'/detail-s/:id', component:DetailS, name:'site-view-s', props:(route) => { return {id:route.params.id, back:route.params.back, skus:route.query.skus} }},
    // {path:'/order-s/:id', component: OrderS, name:'site-order-s', props:true },
    {path:'/items', component:ItemList, name:'item-list', props: true},
    {path:'/item/:id', component:ItemDetail, name:'item-detail', props: true},
    {path:'/register/:xjid?', component:Register, name:'site-register', props: (route) => {
      return {
        xjid: route.params.xjid,
        zsls: route.query.zsls
      }
    }},
    {path:'/stu-bind/:id?', component:StuBind, name:'site-bind', props: (route) => {
      return {id: route.params.id, code: route.query.code}
    }},
    {path:'/stu-list', component:StuList, name:'site-stulist', props: true},
    {path:'/stu-main/:id', component:StuMain, name:'site-stumain', props: true},
    {path:'/stu-info/:id', component:StuInfo, name:'site-stuinfo', props: true},
    {path:'/stu-roll/:id', component:StuRoll, name:'site-sturoll', props: true},
    {path:'/stu-fee/:id', component:StuFee, name:'site-stufee', props: (route) => {
      return { id: route.params.id, feeid: route.query.feeid, add: route.query.add, action: route.params.action };
    }},
    {path:'/signup/:id', component:Signup, name:'site-signup', props: true},
    {path:'/signup-edit/:orderid', component:Signup, name:'site-signup-edit', props: true},
    {path:'/signup-pay', component:SignupPay, name:'signup-pay', props: true},
    {path:'/user', component:User, name:'site-user'},
    {path:'/order/:id', component:SignupOrder, name:'site-order', props: true},
    {path:'/weixin', component:Weixin, name:'site-weixin', props: (route) => {
      return {result: route.query.result};
    }},
    // {path:'/ssign', component:Ssign, name:'site-sign', props: (route) => {
    //   return {};
    // }},
    // {path:'/home2', component:Home2, name:'site-home2'},
    {path:'/about', component:About, name:'site-about'},
  ],
  // shop: [
  //   {
  //     path: '/shop',
  //     component: Shop,
  //     props: (route) => ({ token: route.query.t }),
  //     children: [
  //       {path: '', component: ShopGoods, name:'mall-shop', props:true },
  //       // {path: 'recommend', component: ShopRecommend, name:'shop-goods-recommend'},
  //     ]
  //   },
  //   {path: '/good/:id', component: ShopGoodDetail, name:'shop-goods-detail', props:(route) => { return {id:route.params.id, skus:route.query.skus} } },
  //   {path: '/goods-pay', component: ShopGoodsPay, name:'goods-pay', props:true},
  //   {path: '/user', component:ShopUser, name:'shop-user'},
  //   {path: '/user/detail', component:UserDetail},
  //   {path: '/user/address', component:UserAddress, name:'user-address', props:true},
  //   {path: '/user/address-edit', component:UserAddressEdit, name:'user-address-edit', props:true},
  //   {path: '/orders', component: ShopOrder, name:'shop-orders',
  //     children: [
  //       {path: ':type?', component:ShopOrder0, name:'shop-order-t', props:true}
  //     ]
  //   },
  //   {path: '/order/:id', component: ShopOrderDetail, name:'shop-order-detail', props:true},
  // ],
  // info: [
  //   {path: '/info', component: Info, name:'site-info' },
  //   {path: '/info/signup', component: InfoSignup, name:'site-info-signup' },
  //   {path: '/info/lookup', component: InfoLookup, name:'site-info-lookup' },
  // ],
  // other: [
  //   {path:'/*', component: NotFound},
  // ]
}